/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：50
 */

module.exports = require(/* 1576 */"./1576/index")()
